// Centralized Ant Design color & token configuration

import { message } from "antd";

export const colors = {
    // Primary Brand Colors
    primaryBlue: "#0056D6",
    risingRed: "#E31837",
    ivory: "#FFFFFF",
    midnightBlue: "#050038",
    oxfordBlue: "#001833",
    ceruleanBlue: "#2A6EBB",
    turquoise: "#40E0D0",

    // Status Colors
    success: "#2ABF6B",
    warning: "#FFA940",
    error: "#F44336",
    info: "#1890FF",

    // Neutral Colors
    textBase: "#16212A",
    textSecondary: "#586273",
    steelGrey: "#4D4D4F",
    lightGrey: "#E6E7E8",
    inkBlack: "#231F20",

    // Light Theme
    lightBgBase: "#FAFBFF",
    lightBgContainer: "#FFFFFF",
    lightBorder: "#D9D9D9",
    lightHover: "#F5F7FA",

    // Dark Theme (Ant Design Pro Real Dark)
    darkBgBase: "#141414",
    darkBgElevated: "#1F1F1F",
    darkBgHover: "#262626",
    darkBorder: "#303030",
    darkText: "#FFFFFF",
    darkTextSecondary: "#BFBFBF",
    headerDark: "#1F1F1F",
    sidebarDark: "#1F1F1F",

    // Layout (Light)
    headerLight: "#FFFFFF",
    sidebarLight: "#F7F7F7",

    // Ant Design Default Primary
    antPrimary: "#1677ff",

    // Map Colors
    mapPinGlobal: "#FF6B6B",
    mapPinNational: "#FFC107",
    mapPinCity: "#4CAF50",
    mapPinGroup: "#6C5CE7",
    mapPinSponsor: "#00B8D9",
    mapPinProclamation: "#FF9800",
    mapHeatLow: "rgba(255, 221, 89, 0.3)",
    mapHeatHigh: "rgba(255, 69, 58, 0.8)",

    // Dashboard Chart Colors
    chartBlue: "#3B82F6",
    chartPurple: "#8B5CF6",
    chartGreen: "#10B981",
    chartYellow: "#FACC15",
    chartRed: "#EF4444",
    chartCyan: "#06B6D4",
};

const controlHeight = 30;

const antdTheme = {
    hashed: false,
    cssVar: false,          // disable css variables
    token: {
        fontSize: 14,
        borderRadius: 4,
        controlHeight: controlHeight,
        fontFamily: "Inter, sans-serif",
        fontFamilyHeading: "Inter, sans-serif",
        zIndexPopupBase: 1000,
    },

    components: {
        Typography: {
            "titleMarginTop": "0em",
            "titleMarginBottom": "0em",
        },
        Layout: {
            headerPadding: "0px 10px",
            headerHeight: 48
        },
        Button: {
            controlHeight: controlHeight,
        },
        Avatar: {
            containerSize: controlHeight
        },
        Input: {
            controlHeight: controlHeight + 2 ,
        },
        Menu: {
            fontSize: 16,
        },
        Checkbox: {
            controlInteractiveSize: 18,
            borderRadiusSM: 2,
        },
        Divider: {
            colorSplit: colors?.ceruleanBlue,
            verticalMarginInline: 4
        },
        Message: {
            zIndexPopup: 1100
        },
        Notification: {
            zIndexPopup: 1050,
        },
        Image: {
            zIndexPopup: 1080,
        },
    }
};

export default antdTheme;
